import { stores } from './shared/stores';
import { swReadyState } from './swReadyState';

/** 只在原始视频 URL 已报 CODE:4 时考虑兼容；正常播放不调用此分支。 */
export const canRecoverSafariMp4 = ( options: {
    currentUrl: string;
    finalSrc: string;
    playbackErrorCode: number;
}): boolean => {

    const ua = navigator.userAgent;
    return options.playbackErrorCode === 4
        && /^https?:\/\//i.test( options.currentUrl )
        && options.finalSrc === options.currentUrl
        && ua.includes( 'AppleWebKit' ) && ua.includes( 'Safari/' )
        && !/Chrome|Chromium|CriOS|Edg|OPR|OPiOS|FxiOS|Firefox|Android/.test( ua )
        && swReadyState.isReady && Boolean( navigator.serviceWorker?.controller );

};

/** 只检查未加密与 SW 能力；复用播放器的 controller 处理切源取消和 5 秒超时。 */
export const prepareSafariMp4CompatibilityUrl = async ( url: string, controller: AbortController ): Promise<string | null> => {

    const { signal } = controller;
    const swController = navigator.serviceWorker?.controller;
    if ( signal.aborted || !swReadyState.isReady || !swController ) return null;

    // IDB 不支持 AbortSignal，需同时等待取消，避免界面一直停在恢复中。
    let rejectAbort!: () => void;
    const aborted = new Promise<never>(( _resolve, reject ) => {

        rejectAbort = () => {

            reject( new DOMException( 'MP4 compatibility setup aborted', 'AbortError' ));

        };
        signal.addEventListener( 'abort', rejectAbort, { once: true });

    });
    const timer = setTimeout(() => {

        controller.abort();

    }, 5000 );

    try {

        // keyId="0" 按接口约定表示未加密；其他加密记录即使密钥详情暂缺也必须排除。
        const encryptInfo = await Promise.race( [stores.encryptKey.get( url ), aborted] );
        if ( signal.aborted || ( encryptInfo && encryptInfo.keyId !== '0' )) return null;

        // 旧 SW 可能已控制页面但尚不认识兼容路径，必须确认能力后再切换 src。
        const response = await Promise.race( [fetch( '/__sw_probe__', { cache: 'no-store', signal }), aborted] );
        if ( signal.aborted || navigator.serviceWorker.controller !== swController
            || response.status !== 200 || response.headers.get( 'x-safari-mp4' ) !== 'url-v1' ) return null;
        // 整个原串编码，SW 只解码一次，保持签名参数的顺序、转义和加号不变。
        return new URL( `/__safari_mp4__/?url=${encodeURIComponent( url )}`, location.origin ).href;

    } finally {

        clearTimeout( timer );
        signal.removeEventListener( 'abort', rejectAbort );

    }

};
